import axios from "axios";
import { createStore } from 'devextreme-aspnet-data-nojquery';
export const GetSearchLocationQuantitySummary = (accessToken, url,formFields) => {
    const resultData = createStore({
      key: 'rowid',
      loadParams:
      {
        Item: function () {
          return formFields.Item;
        },
        ItemDescription: function () {
          return formFields.ItemDescription;
        },
        Lot: function () {
          return formFields.Lot;
        },
        LotDescription: function () {
          return formFields.LotDescription;
        },
        location: function () {
          return formFields.location;
        },
        LocationDescription: function () {
          return formFields.LocationDescription;
        },
        Warehouse: function () {
          return formFields.Warehouse;
        },
        Unit: function () {
          return formFields.Unit;
        },
        Sublot: function () {
          return formFields.Sublot;
        },
        Customer: function () {
          return formFields.Customer;
        },
        InTransactionNumber: function () {
          return formFields.InTransactionNumber;
        }
      },
      loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
      onBeforeSend: (method, ajaxOptions) => {
        ajaxOptions.headers = {
          access_token: accessToken,
          Authorization: `Bearer ${accessToken}`,
        };
      },
    });
    return resultData;
  };